import { nombre_municipio, visor_id } from '../../configComponent/update-vars'
import {PYTHON_URL} from '../urls'
import { consultaB } from '../../../consultaB'



//Api to login
export function PostRequest_Login(user, password, codigo_municipio){
    return fetch(PYTHON_URL+`autenticacion/token/${visor_id}/${codigo_municipio}`, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: user,
          password: password,
        }),
    })
    
};

//Api to verify access to a certain portal
export function GetRequest(param,token){
    return fetch(PYTHON_URL+param, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + token
        }
        
    })
    
};

// API to verify the token using fetch
export function Post_checkToken(Token) {
    return fetch(PYTHON_URL + 'autenticacion/token/verify/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: Token })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
    .catch(error => {
        console.error("Error verifying token:", error);
        throw error; // Propagar el error para manejarlo externamente
    });
}


//Api to recover password
export function GetRequest_Email(email){
    return fetch(PYTHON_URL+'autenticacion/recuperacion_contrasena/'+email, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        }
        
    })
   
};


//Registrar datos de ususario en login y recuperacion de contraseña 
export const  guardarDatosLogin=(params,datos,token)=>{
    fetch(PYTHON_URL+params, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(datos)
    })
    .then(function (response) {        
        if(datos.operacion==`Inicio sesión App Móvil - ${nombre_municipio}`){
            document.location.href="./index.html?b="+consultaB();
        }else{
            /* console.log(response); */
        }
    })
    .catch(function (error) {
        if(datos.operacion==`Inicio sesión App Móvil - ${nombre_municipio}`){
            document.location.href="./index.html?b="+consultaB();
        }else{
            /* console.log(response); */
        }
    });     
}     


//Api to verify access to a certain portal
export function GetDataForm(param){
    var token_id = sessionStorage.getItem('token-access');
    return fetch(PYTHON_URL+'formulario/'+param, {
        method: "GET",
        headers: {
            "Authorization": "Bearer "+ token_id
          }
    })
    
};

export function pythonPostRequestSqlStadistics(sqlCrudo){

    var token_id = sessionStorage.getItem('token-access');
    var formdata = new FormData();
    formdata.append("strsql", sqlCrudo);

    return fetch(PYTHON_URL+'estadisticas/raw/', {
        method: "POST",
        headers: {
          "Authorization": "Bearer "+ token_id
        },
        body: formdata
    })
};


///plataformas
export function GetPlataformasMoviles(param){
    return fetch(PYTHON_URL+param, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        }
        
    })
    
};